import React from 'react';
import Image from 'components/Image';
import "./ProfileImage.css";

const ProfileImage = React.memo(({ src, className = 'medium' }: { src: string, className?: string }) => {
    return <Image zoomWidth={1} src={src} className={`rounded-circle img-profile ${className}`} />;
});

export default ProfileImage;
